
import ajax from "./ajax";

export const listByPage = params => ajax(`/business/listByPage`, params,'POST');
export const insert = params => ajax(`/business/insert`, params,'POST');
export const update = params => ajax(`/business/update`, params,'POST');
export const del = params => ajax(`/business/delete`, params,'POST');
export const querySingle = params => ajax(`/business/querySingle`, params,'POST');

export const listBySort = params => ajax(`/business/listBySort`, params,'POST');
export const updateFileSort = params => ajax(`/business/updateFileSort`, params,'POST');

// 说明
export const listByPageExp = params => ajax(`/busExplain/listByPage`, params,'POST');
export const deleteMutil = params => ajax(`/busExplain/deleteMutil`, params,'POST');
export const updateExp = params => ajax(`/busExplain/update`, params,'POST');
export const querySingleExp = params => ajax(`/busExplain/querySingle`, params,'POST');
export const insertExp = params => ajax(`/busExplain/insert`, params,'POST');


 

// 前端
export const allList = params => ajax(`/bushome/allList`, params,'POST');//业务介绍
export const busExplainList = params => ajax(`/bushome/busExplainList`, params,'POST');































